module.exports = __webpack_public_path__ + "assets/media/og.a045fe02.png";